import { useBoxContext as o } from "./index.es521.js";
function r() {
  const t = o();
  return t == null ? void 0 : t.boxState;
}
export {
  r as useBoxState
};
//# sourceMappingURL=index.es523.js.map
